exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mybtn {\r\n  display: none;\n}\n.hide {\r\n  display: inline-block !important;\n}\n.tit {\r\n  border-bottom: 1px solid #ccc;\r\n  padding-bottom: 10px;\r\n  margin-bottom: 10px;\r\n  font-size: 14px;\n}\r\n", ""]);

// exports
